import React from 'react';

import { Flex, Typography } from 'antd';

import CopyToClipboard from '@/components/CopyToClipboard';

interface ICopyableTextProps {
  value: string | undefined;
}

export const CopyableText = ({ value }: ICopyableTextProps) => (
  <Flex align="center" gap={4}>
    <Typography.Text>{value || '-'}</Typography.Text>
    {value && (
      <Flex align="center" onClick={(e) => e.stopPropagation()}>
        <CopyToClipboard data={value} />
      </Flex>
    )}
  </Flex>
);
